import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

/** 动账明细分页 */
export function getAccountFlowPageAPI(params) {
  return http({
    url: "/admin/store/finance/bill/page",
    method: "get",
    params,
  });
}

/** 动账明细导出，下载 Excel 文件 */
export function exportAccountFlowAPI(data) {
  showScreenLoading();
  return axios({
    method: "post",
    url: "/api/admin/store/finance/bill/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then((res) => {
      hideScreenLoading();
      const blob = res.data;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      const filename = `动账记录${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch(() => {
      hideScreenLoading();
    });
}
